<template lang="pug">
.robot-design.robot3s
  #design-b1.banner
    .bg-mask(:class="{fadeUp: isB1Visible}")
      .p1.delay1(:class="{fadeUp: isB1Visible}") 机器人运营管理平台
      .p2.delay2(:class="{fadeUp: isB1Visible}") 将机器人等多智能终端和机构运营管理服务相结合
      .p2.delay3(:class="{fadeUp: isB1Visible}") 将管理长者安全守护/生活照护智能服务与机构处理通报流程整合为一体化的AI运营管理平台
      .item.delay4(:class="{fadeDown: isB1Visible}")
        img(v-if="isMobile",src="../../../assets/mobile/3s-platform-img1.png")
        img(v-else,src="../../../assets/web/3s-platform-img1.png")
  #design-b2.banner
    .p1.delay1(:class="{zoomOut: isB2Visible}") 登录界面
    .item.delay2(:class="{zoomOut: isB2Visible}")
      img(v-if="isMobile",src="../../../assets/mobile/3s-platform-img2.png")
      img(v-else,src="../../../assets/web/3s-platform-img2.png")
  #design-b3.banner
    .p1.delay1(:class="{zoomOut: isB3Visible}") 公告界面
    .item.delay2(:class="{zoomOut: isB3Visible}")
        img(v-if="isMobile",src="../../../assets/mobile/3s-platform-img3.png")
        img(v-else,src="../../../assets/web/3s-platform-img3.png")
  #design-b4.banner
    .p1.delay1(:class="{zoomOut: isB4Visible}") 视频通话界面
    .item.delay2(:class="{zoomOut: isB4Visible}")
      img(v-if="isMobile",src="../../../assets/mobile/3s-platform-img4.png")
      img(v-else,src="../../../assets/web/3s-platform-img4.png")

  #design-b5.banner
    .p1.delay1(:class="{zoomOut: isB5Visible}") 工单界面
    .item.delay2(:class="{zoomOut: isB5Visible}")
      img(v-if="isMobile",src="../../../assets/mobile/3s-platform-img5.png")
      img(v-else,src="../../../assets/web/3s-platform-img5.png")
  #design-b6.banner
    .p1.delay1(:class="{zoomOut: isB6Visible}") 概览界面
    .item.delay2(:class="{zoomOut: isB6Visible}")
      img(v-if="isMobile",src="../../../assets/mobile/3s-platform-img6.png")
      img(v-else,src="../../../assets/web/3s-platform-img6.png")
  #design-b7.banner
    .p1.delay1(:class="{zoomOut: isB7Visible}") 发布公告
    .item.delay2(:class="{zoomOut: isB7Visible}")
      img(v-if="isMobile",src="../../../assets/mobile/3s-platform-img7.png")
      img(v-else,src="../../../assets/web/3s-platform-img7.png")
  #design-b8.banner
      .p1.delay1(:class="{fadeUp: isB8Visible}") 多维闭环机器人智能运营
      .item
        .delay2(v-if="isMobile",:class="{fadeDown: isB8Visible}")
          img(src="../../../assets/mobile/3s-platform-img8.png",class="img1")
          img(src="../../../assets/mobile/3s-platform-img9.png", class="img2")
        .delay2(v-if="!isMobile",:class="{fadeDown: isB8Visible}")
          img(src="../../../assets/web/3s-platform-img8.png",class="img1")
          img(src="../../../assets/web/3s-platform-img9.png", class="img2")
</template>

<script>
import { isVisible } from '../../../common/utils'

export default {
  data () {
    return {
      robot3Show: DB.robot3Show,
      isB1Visible: true,
      isB2Visible: false,
      isB3Visible: false,
      isB4Visible: false,
      isB5Visible: false,
      isB6Visible: false,
      isB7Visible: false,
      isB8Visible: false,
    }
  },
  computed: {},
  methods: {
  },
  created () {
    $(window).on('scroll', () => {
      this.isB1Visible = isVisible('#design-b1')
      this.isB2Visible = isVisible('#design-b2')
      this.isB3Visible = isVisible('#design-b3')
      this.isB4Visible = isVisible('#design-b4')
      this.isB5Visible = isVisible('#design-b5')
      this.isB6Visible = isVisible('#design-b6')
      this.isB7Visible = isVisible('#design-b7')
      this.isB8Visible = isVisible('#design-b8')
    })
  },
}
</script>

<style lang="stylus">
@import 'config'
.robot-design.robot3s
  color #fff
  #design-b1
    position relative
    min-width 1200px
    height 800px
    overflow hidden
    background url('../../../assets/web/3s-platform-bg.png') no-repeat center
    .bg-mask
      position absolute
      top 0
      left 0
      width 100%
      height 100%
      background-size auto 100%
      text-align center
    .p1
      margin-top 44px
      font-size 31px
      padding-bottom 10px
      text-align center
    .p2
      font-size 18px
      padding-bottom 10px
    .item
      img
        margin-top 55px
  #design-b2, #design-b3, #design-b4, #design-b5, #design-b6, #design-b7
    display flex
    background-image url('../../../assets/web/3s-platform-bg.png')
    .p1
      font-size 25px
    .item
      display inline
  #design-b2
    .p1
      margin-left 325px
      margin-top 39px
    .item
      width 526px
      img
        margin-top 28px
        margin-left 35px
  #design-b3
    .p1
      margin-left 325px
      margin-top 39px
    .item
      width 571px
  #design-b4
    .p1
      margin-left 276px
      margin-top 39px
    .item
      width 548px
  #design-b5
    .p1
      margin-left 325px
      margin-top 39px
    .item
      width 556px
  #design-b6
    .p1
      margin-left 325px
      margin-top 39px
    .item
      width 543px
  #design-b7
    .p1
      margin-left 325px
      margin-top 39px
    .item
      width 546px
  #design-b8
    position relative
    min-width 1200px
    height 800px
    overflow hidden
    background url('../../../assets/web/3s-platform-bg.png') no-repeat center
    text-align center
    .p1
      margin-top 80px
      font-size 31px
      padding-bottom 10px
      text-align center
    .delay2
      .img1
        margin-top 120px
        margin-left 320px
        width 743px
      .img2
        margin-top 31px
        margin-left 113px
        width 191px
  .banner
    height 800px
    min-width 1200px
    background-size auto 100%
    background-position center
    background-repeat no-repeat
.is-mobile
  .robot3s
    #design-b1, #design-b2, #design-b3, #design-b4, #design-b5, #design-b6, #design-b7, #design-b8
      width 100%
      min-width inherit
      height r(1100)
      background-image url('../../../assets/mobile/3s-platform-bg.png')
      flex-direction column
    #design-b1
      text-align center
      .p1
        font-size 20px
        padding-bottom 14px
      .p2
        font-size 7px
      .item
        img
          margin-top 10px
    #design-b2
      .p1
        margin-left 51px
        margin-top 118px
      .item
        width 290px
        img
          margin-top 28px
          margin-left 42px
    #design-b3
      .p1
        margin-left 51px
        margin-top 118px
      .item
        width 306px
        img
          margin-top 21px
          margin-left 35px
    #design-b4
      .p1
        margin-left 50px
        margin-top 118px
      .item
        width 306px
        img
          margin-left 35px
          margin-top 21px
    #design-b5
      .p1
        margin-left 49px
        margin-top 118px
      .item
        width 305px
        img
          margin-top 22px
          margin-left 35px
    #design-b6
      .p1
        margin-left 49px
        margin-top 118px
      .item
        width 291px
        img
          margin-top 29px
          margin-left 41px
    #design-b7
      .p1
        margin-left 49px
        margin-top 118px
      .item
        width 306px
        img
          margin-top 22px
          margin-left 33px
    #design-b8
      .p1
        font-size 20px
      .delay2
        .img1
          margin-top 58px
          margin-left 11px
          width 354px
        .img2
          margin-top 44px
          margin-left 233px
          width 102px
  .robot-design
    .p1
      font-size r(46)
    .p2
      font-size r(24)
</style>



// WEBPACK FOOTER //
// src/views/robot/3s/design.vue